export default "__VITE_ASSET__BeD044xQ__"